import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { toHttpParams } from '../project/helpers/to-http-params';
import { NotificationContentQuery, NotificationContentBody } from './types';
import { LoadResult } from '../types';
import { ViewNotificationContent } from 'studio-components';

const BASE_URL = `${environment.apiOrg.url}/admin/notification/content`;

@Injectable()
export class NotificationContentService {
  constructor(private http: HttpClient) {}

  load(query: Partial<NotificationContentQuery>) {
    return this.http.get<LoadResult<ViewNotificationContent>>(BASE_URL, {
      params: toHttpParams({ filter: JSON.stringify(query) }),
    });
  }

  create(body: NotificationContentBody) {
    return this.http.post<ViewNotificationContent>(BASE_URL, body);
  }

  update(id: number, body: NotificationContentBody) {
    return this.http.patch<ViewNotificationContent>(`${BASE_URL}/${id}`, body);
  }

  getById(id: number) {
    return this.http.get<ViewNotificationContent>(`${BASE_URL}/${id}`);
  }

  delete(id: number) {
    return this.http.delete(`${BASE_URL}/${id}`);
  }

  publish(id: number) {
    return this.http.post(`${BASE_URL}/${id}/publish`, {});
  }
}
